module.exports = __webpack_public_path__ + "static/media/bts_veld_170805_003_small.1eac5757.jpg";